var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"border-primary rounded-circle",class:_setup.avatarClass,attrs:{"src":_setup.localUrl ? _setup.localUrl : require('./assets/no-photo.jpg'),"alt":"avatar"},on:{"error":function($event){_setup.localUrl = null}}})
}
var staticRenderFns = []

export { render, staticRenderFns }